import { computed } from "vue";

const query_string = require('query-string');

import SelectedPlan from "src/composables/SelectedPlan";
import ServiceStartDate from "src/composables/ServiceStartDate";
import ServiceLocation from "src/composables/ServiceLocation";
import CustomerInformation from "src/composables/CustomerInformation";
import UsageFilters from "src/composables/UsageFilters";
import Tdsps from "src/composables/Tdsps";

const { zip_code } = Tdsps();
const { selected_plan, is_plan_valid } = SelectedPlan();
const { all_valid, action, selected_start_date } = ServiceStartDate();
const {
    service_location,
    get_service_location_by_key,
    property_type,
    owns_property,
    duns_match,
    service_location_valid
} = ServiceLocation();
const { first_name, last_name, email, phone_number, spanish } = CustomerInformation();
const { usage_type, show_historical_usage, historical_usage, usage_selected } = UsageFilters()

const order_query_string = computed(() => {
    let query_string_object = {
        ...zip_code.value && { zip_code: zip_code.value },
        ...(selected_plan.value && is_plan_valid.value) && { plan_id: selected_plan.value._id },
        ...first_name.value && { first_name: first_name.value },
        ...last_name.value && { last_name: last_name.value },
        ...email.value && { email: email.value },
        ...phone_number.value && { phone_number: phone_number.value },
        ...spanish.value && { language: 'spanish' },
        ...(service_location?.value && service_location_valid.value) && { esiid: service_location.value.esiid },
        ...action.value && { action: action.value },
        ...(selected_start_date.value && all_valid.value) && { selected_start_date: selected_start_date.value },
        ...(typeof owns_property.value === 'boolean') && { owns_property: owns_property.value },
        ...property_type.value && { property_type: property_type.value },
    };
    if (show_historical_usage.value) {
        query_string_object.historical_usage = historical_usage.value.map(x => isNaN(x.usage) ? '' : x.usage)
    }
    else {
        query_string_object.usage = usage_selected.value
    }
    return query_string.stringify(query_string_object);
})

const url = computed(() => `${ location.protocol }//${ location.host }${ location.pathname }`);
const order_link = computed(() => {
    return `${ url.value }?${ order_query_string.value }`;
})

export default () => {
    return {
        order_query_string,
        order_link
    }
}
